import React, { Component } from "react";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import NativeSelect from "@material-ui/core/NativeSelect";
import Input from "@material-ui/core/Input";
import { getErrorString } from "../display/ErrorStrings";
import { withStyles } from "@material-ui/core/styles";
import { withTranslation } from "react-i18next";
import SuspectItemDetails from "../details/SuspectItemDetails";
import PopupMessage from "../components/PopupMessage";

import SaveIcon from "@material-ui/icons/SaveOutlined";
import SummaryViewIcon from "@material-ui/icons/ExpandLessOutlined";
import InfoIcon from "@material-ui/icons/InfoOutlined";

import CircularProgress from "@material-ui/core/CircularProgress";

import CustomPaginatorActions from "../components/CustomPaginatorActions";
import TablePagination from "@material-ui/core/TablePagination";

import Tooltip from "@material-ui/core/Tooltip";

import { ROWS_PER_PAGE_OPTIONS } from "../components/Constants";

const styles = (theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
  },
  spacer: {
    flex: "1 1 100%",
  },
  table: {
    border: "1px solid black",
    margin: "20px",
    width: 700,
  },
  progress: {
    margin: theme.spacing.unit,
  },
  paper: {
    height: 600,
    width: "100%",
    marginTop: theme.spacing.unit * 3,
    overflow: "auto",
  },
});

class HomePageChecksExpanded extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorString: "",
      saveErrorString: "",
      checkAccounts: [],
      selectedItemObject: {},
      selectedAccountIndex: 0,
      noExceptions: false,
      returnCodes: [],
      notes: "",
      saving: false,
      loading: false,
      viewPopup: false,
      totalCount: 0,
      page: 0,
      rowsPerPage: window.sco_large_items_per_page,
    };
    this.onClosePopup = this.onClosePopup.bind(this);
    this.onDisposition = this.onDisposition.bind(this);
  }

  onClosePopup(e) {
    this.setState({ selectedAccountIndex: 0 });
    this.setState({ saveErrorString: "" });
  }

  onDisposition(e) {
    let accounts = this.state.checkAccounts;
    let i;
    let items = accounts[this.state.selectedAccountIndex - 1].items;
    if (items.length === 1) {
      accounts.splice(this.state.selectedAccountIndex - 1, 1);
      if (accounts.length > 0) {
        for (i = 0; i < accounts.length; i++) {
          accounts[i].index = i + 1;
        }
      }
    } else {
      items.splice(this.state.selectedItemObject.index - 1, 1);
      for (i = 0; i < items.length; i++) {
        items[i].index = i + 1;
      }
    }

    this.setState({ selectedAccountIndex: 0 });
    this.setState({ checkAccounts: accounts });
    if (accounts.length === 0) {
      this.setState({ noExceptions: true });
    }
  }

  componentDidMount() {
    this.search(0, this.state.rowsPerPage);
  }

  handleChangeRowsPerPage(e) {
    this.setState({ rowsPerPage: e.target.value });
    this.setState({ page: 0 });
    window.sco_large_items_per_page = e.target.value;
    this.search(0, e.target.value);
  }

  handleChangePage = (event, page) => {
    this.setState({ page: page });
    this.search(page, this.state.rowsPerPage);
  };

  search(page, rowsPerPage) {
    this.setState({ noExceptions: false });
    this.setState({ loading: true });
    var accountsList = {};
    accountsList.secureToken = this.props.secureToken;
    accountsList.accountsData = this.props.accounts;
    accountsList.page = page;
    accountsList.rowsPerPage = rowsPerPage;
    fetch("on_check_exception_expanded_home_page_search", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(accountsList),
    })
      .then(function (res) {
        if (!res.ok) {
          throw Error(res.status + " (" + res.statusText + ")");
        }
        return res;
      })
      .then((res) => res.text())
      .then((text) => {
        var reply = JSON.parse(text);
        if (reply.authenticated === false) {
          this.props.history.push("/expired");
        } else if (reply.error) {
          this.setState({ errorString: reply.errorString });
          this.setState({ loading: false });
        } else {
          this.setState({ checkAccounts: reply.accounts });
          this.setState({ returnCodes: reply.returnCodes });
          this.setState({ totalCount: reply.totalCount });
          if (reply.accounts.length === 0) {
            this.setState({ noExceptions: true });
          }
          this.setState({ loading: false });
        }
      })
      .catch((error) => {
        this.setState({
          errorString:
            getErrorString(
              "general.server.status.error",
              "The server responded with a status of "
            ) + error.message,
        });
        this.setState({ loading: false });
      });
  }

  handleSelectAccount(e, index, check) {
    this.setState({ selectedAccountIndex: index });
    this.setState({ selectedItemObject: check });
  }

  handleSummaryView(evenr) {
    this.props.onClose();
  }

  handleNotes(e) {
    this.setState({ notes: e.target.value });
  }

  handleSave(e) {
    if (this.props.viewOnly) {
      this.setState({
        errorString: getErrorString(
          "viewOnly.warning",
          "Operation not allowed in support mode."
        ),
      });
      this.setState({ viewPopup: true });
      return;
    }
    let accounts = this.state.checkAccounts;
    let saveEmpty = true;
    let i;
    let j;
    for (i = 0; i < accounts.length; i++) {
      for (j = 0; j < accounts[i].items.length; j++) {
        if (accounts[i].items[j].status === "1") {
          saveEmpty = false;
        }
        if (accounts[i].items[j].status === "2") {
          saveEmpty = false;
          if (accounts[i].items[j].statusDescr === "000") {
            this.setState({
              saveErrorString:
                "Return Reason is required for each Return action.",
            });
            return;
          }
        }
      }
    }
    if (saveEmpty) {
      this.setState({ saveErrorString: "Nothing to save" });
      return;
    }
    this.setState({ saving: true });
    fetch("on_extended_check_disposition_save", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        accounts: this.state.checkAccounts,
        comments: this.state.notes,
        secureToken: this.props.secureToken,
      }),
    })
      .then(function (res) {
        if (!res.ok) {
          throw Error(res.status + " (" + res.statusText + ")");
        }
        return res;
      })
      .then((res) => res.text())
      .then((text) => {
        var reply = JSON.parse(text);
        if (!reply.authenticated) {
          this.props.history.push("/expired");
        } else {
          this.setState({ saving: false });
          this.componentDidMount();
          if (reply.error) {
            this.setState({ saveErrorString: reply.errorString });
          }
        }
      })
      .catch((error) => {
        this.setState({
          errorString:
            getErrorString(
              "general.server.status.error",
              "The server responded with a status of "
            ) + error.message,
        });
        this.setState({ saving: false });
      });
  }

  handleReturnCode(e, item) {
    item.statusDescr = e.target.value;
  }

  handleAction(e, item) {
    let togleReason = false;
    if (item.status === "2" || e.target.value === "2") {
      togleReason = true;
    }
    item.status = e.target.value;
    if (togleReason) {
      item.statusDescr = "000";
      let accounts = this.state.checkAccounts;
      this.setState({ checkAccounts: accounts });
    }
  }

  render() {
    let checkAccounts = this.state.checkAccounts;
    let { t } = this.props;
    const { classes } = this.props;
    const { rowsPerPage, page, totalCount } = this.state;
    return (
      <div>
        <div>
          {this.state.saveErrorString.length > 0 && (
            <PopupMessage
              title={getErrorString("general.error", "Error")}
              text={this.state.saveErrorString}
              error={true}
              onClosePopup={this.onClosePopup}
            />
          )}
          {this.state.errorString.length > 0 && (
            <div>
              <h3 style={{ color: "red" }}>{this.state.errorString} </h3>
              <Button
                color="primary"
                onClick={(event) => this.handleSummaryView(event)}
              >
                <SummaryViewIcon />
                &nbsp;{t("summaryView.button")}
              </Button>
            </div>
          )}
          {this.state.noExceptions && !this.state.loading && (
            <h3 style={{ color: "primary" }}>
              &nbsp;&nbsp;{t("noItemFound.label")}{" "}
            </h3>
          )}
          {this.state.checkAccounts.length === 0 &&
            this.state.errorString.length === 0 &&
            this.state.loading && (
              <div>
                <br></br>
                <CircularProgress className={classes.progress} />
              </div>
            )}

          {this.state.selectedAccountIndex !== 0 && (
            <div style={{ marginTop: 20 }}>
              <Typography variant="body1" color="primary">
                &nbsp;&nbsp;{t("selectedTransit.label")}&nbsp;
                <span>
                  <strong>
                    {
                      this.state.checkAccounts[
                        this.state.selectedAccountIndex - 1
                      ].transit
                    }
                  </strong>
                </span>
                &nbsp;{t("account.label")}&nbsp;
                <span>
                  <strong>
                    {
                      this.state.checkAccounts[
                        this.state.selectedAccountIndex - 1
                      ].account
                    }
                  </strong>
                </span>
              </Typography>
              <SuspectItemDetails
                scrub={false}
                uiExclusionsList={this.props.uiExclusionsList}
                viewOnly={this.props.viewOnly}
                secureToken={this.props.secureToken}
                item={this.state.selectedItemObject}
                history={this.props.history}
                accountObject={
                  this.state.checkAccounts[this.state.selectedAccountIndex - 1]
                }
                onClosePopup={this.onClosePopup}
                returnCodes={this.state.returnCodes}
                onDisposition={this.onDisposition}
              />
            </div>
          )}

          {this.state.errorString.length === 0 &&
            this.state.selectedAccountIndex === 0 &&
            !this.state.loading &&
            !this.state.noExceptions && (
              <div>
                {this.state.checkAccounts.length > 0 && (
                  <div style={{ margin: 20 }}>
                    <Typography variant="h6" color="primary">
                      {t("checkExceptions.label")}
                      <Tooltip
                        classes={{ tooltip: classes.customWidth }}
                        title={<div>{t("snapshot.tip")}</div>}
                      >
                        <InfoIcon color="primary" />
                      </Tooltip>
                      &nbsp;&nbsp;
                      <Button
                        color="primary"
                        style={{ position: "absolute", right: 20 }}
                        onClick={(event) => this.handleSummaryView(event)}
                      >
                        <SummaryViewIcon />
                        &nbsp;{t("summaryView.button")}
                      </Button>
                    </Typography>
                    <Typography color="primary" variant="body1">
                      {" "}
                      {t("selectAction.label")}
                    </Typography>
                    <Typography color="primary" variant="body1">
                      {" "}
                      {t("notePendingMissing.label")}{" "}
                      {t("viewItemDetails.label")}
                    </Typography>
                    <div style={{ marginBottom: 10 }}>
                      <TextField
                        margin="dense"
                        id="notes"
                        label={t("notes.label")}
                        type="text"
                        onChange={(event) => this.handleNotes(event)}
                      />
                      &nbsp;&nbsp;
                      <Button
                        color="primary"
                        onClick={(event) => this.handleSave(event)}
                        disabled={this.state.saving}
                      >
                        <SaveIcon />
                        &nbsp;{t("saveChanges.button")}
                      </Button>
                    </div>
                    <div>
                      <div style={{ margin: 20 }}>
                        <Paper className={classes.paper}>
                          <TablePagination
                            component="div"
                            count={totalCount}
                            rowsPerPage={rowsPerPage}
                            rowsPerPageOptions={ROWS_PER_PAGE_OPTIONS}
                            page={page}
                            onChangePage={this.handleChangePage}
                            onChangeRowsPerPage={(event) =>
                              this.handleChangeRowsPerPage(event)
                            }
                            ActionsComponent={CustomPaginatorActions}
                          />
                          <Table stickyHeader>
                            <TableHead>
                              <TableRow>
                                <TableCell style={{ width: "8%", padding: 10 }}>
                                  <Typography
                                    variant="subtitle1"
                                    color="primary"
                                  >
                                    {t("date.header")}
                                  </Typography>
                                </TableCell>
                                <TableCell style={{ width: "12%", padding: 0 }}>
                                  <Typography
                                    variant="subtitle1"
                                    color="primary"
                                  >
                                    {t("trace.header")}
                                  </Typography>
                                </TableCell>
                                <TableCell
                                  style={{ width: "10%", padding: 0 }}
                                  numeric={true}
                                >
                                  <Typography
                                    variant="subtitle1"
                                    color="primary"
                                  >
                                    {t("checkNumber.header")}{" "}
                                  </Typography>
                                </TableCell>
                                <TableCell
                                  style={{ width: "10%", padding: 0 }}
                                  numeric={true}
                                >
                                  <Typography
                                    variant="subtitle1"
                                    color="primary"
                                  >
                                    {t("amount.header")}
                                  </Typography>
                                </TableCell>
                                <TableCell style={{ width: "25%" }}>
                                  <Typography
                                    variant="subtitle1"
                                    color="primary"
                                  >
                                    {t("payee.header")}
                                  </Typography>
                                </TableCell>
                                <TableCell style={{ width: "12%", padding: 0 }}>
                                  <Typography
                                    variant="subtitle1"
                                    color="primary"
                                  >
                                    {t("reasonRejected.header")}
                                  </Typography>
                                </TableCell>
                                <TableCell style={{ width: "10%", padding: 0 }}>
                                  <Typography
                                    variant="subtitle1"
                                    color="primary"
                                  >
                                    {t("action.header")}
                                  </Typography>
                                </TableCell>
                                <TableCell style={{ width: "13%", padding: 0 }}>
                                  <Typography
                                    variant="subtitle1"
                                    color="primary"
                                  >
                                    {t("returnReason.header")}
                                  </Typography>
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            {checkAccounts.map((account) => {
                              return (
                                <TableBody>
                                  <TableRow key={account.index}>
                                    <TableCell
                                      colSpan={8}
                                      style={{ padding: 10 }}
                                    >
                                      <Typography
                                        variant="body1"
                                        color="primary"
                                      >
                                        {t("transit.label") +
                                          account.transit +
                                          "   /   " +
                                          t("account.label") +
                                          account.account}
                                      </Typography>
                                    </TableCell>
                                  </TableRow>
                                  {account.items.map((item) => {
                                    return (
                                      <TableRow key={item.index}>
                                        <TableCell
                                          style={{ width: "8%", padding: 10 }}
                                        >
                                          {item.date}
                                        </TableCell>
                                        <TableCell
                                          style={{ width: "12%", padding: 0 }}
                                        >
                                          {item.trace}
                                        </TableCell>
                                        <TableCell
                                          style={{ width: "10%", padding: 0 }}
                                        >
                                          <Button
                                            style={{
                                              margin: 0,
                                              padding: 0,
                                              minWidth: 0,
                                              minHeight: 0,
                                            }}
                                            color="primary"
                                            onClick={(event) =>
                                              this.handleSelectAccount(
                                                event,
                                                account.index,
                                                item
                                              )
                                            }
                                          >
                                            {item.checkNumber}
                                          </Button>
                                        </TableCell>
                                        <TableCell
                                          style={{ width: "10%", padding: 0 }}
                                          numeric={true}
                                        >
                                          {item.amount}
                                        </TableCell>
                                        <TableCell
                                          style={{
                                            width: "25%",
                                            wordWrap: "break-word",
                                          }}
                                        >
                                          {item.payee}
                                        </TableCell>
                                        <TableCell
                                          style={{ width: "12%", padding: 0 }}
                                        >
                                          {item.reasonRejected}
                                        </TableCell>
                                        <TableCell
                                          style={{ width: "10%", padding: 0 }}
                                        >
                                          <NativeSelect
                                            defaultValue={item.status}
                                            input={<Input id="action_type" />}
                                            onChange={(event) =>
                                              this.handleAction(event, item)
                                            }
                                          >
                                            <option value="0">
                                              {t("none.label")}
                                            </option>
                                            <option value="1">
                                              {t("pay.label")}
                                            </option>
                                            <option value="2">
                                              {t("return.label")}
                                            </option>
                                          </NativeSelect>
                                        </TableCell>
                                        {item.status !== "2" && (
                                          <TableCell
                                            style={{ width: "13%", padding: 0 }}
                                          ></TableCell>
                                        )}
                                        {item.status === "2" && (
                                          <TableCell
                                            style={{ width: "13%", padding: 0 }}
                                          >
                                            <NativeSelect
                                              defaultValue={item.statusDescr}
                                              input={<Input id="return_code" />}
                                              onChange={(event) =>
                                                this.handleReturnCode(
                                                  event,
                                                  item
                                                )
                                              }
                                            >
                                              {this.state.returnCodes.map(
                                                (n) => {
                                                  return (
                                                    <option value={n.id}>
                                                      {n.description}
                                                    </option>
                                                  );
                                                }
                                              )}
                                            </NativeSelect>
                                          </TableCell>
                                        )}
                                      </TableRow>
                                    );
                                  })}
                                </TableBody>
                              );
                            })}
                          </Table>
                        </Paper>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )}
        </div>
      </div>
    );
  }
}

export default withTranslation()(withStyles(styles)(HomePageChecksExpanded));
